import React from 'react';
import { useSearchParams } from 'react-router-dom';
import VetDashboard from './VetDashboard';

const VetDashboardEmbed: React.FC = () => {
    const [searchParams] = useSearchParams();
    const tab = (searchParams.get('tab') || 'overview') as
        'overview' | 'calendar' | 'patients' | 'records' | 'settings' | 'communications' | 'pos';

    return (
        <div style={{ width: '100%', minHeight: '100vh', overflow: 'hidden' }}>
            <VetDashboard onLogout={() => {}} initialTab={tab} />
        </div>
    );
};

export default VetDashboardEmbed;
